import Breadcrumb from './Breadcrumb';
export default Breadcrumb;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-breadcrumb/src/index.js